import {createContext, useCallback, useContext, useEffect, useState} from 'react'

import {useErrorHandler} from '../../../../_metronic/helpers/ErrorHandler'
import {sortByLabel} from '../../../shared/optionSort'
import * as GisDataAdapter from '../Fields/services/GisDataAdapter'

const SearchContext = createContext()

export function useSearchContext() {
  return useContext(SearchContext)
}

export const SearchConsumer = SearchContext.Consumer

export function SearchProvider({children}) {
  const [options, setOptions] = useState([])
  const [groupedOptions, setGroupedOptions] = useState([])
  const {errorHandler} = useErrorHandler()

  const load = useCallback(() => {
    errorHandler(GisDataAdapter.listSearchIndex()).then((res) => {
      if (!res?.ok) {
        return
      }

      setOptions(sortByLabel(res.data.options || [], (option) => option.label))
      setGroupedOptions(
        sortByLabel(res.data.groupedOptions || [], (field) => field.name).map((field) => ({
          ...field,
          lands: sortByLabel(field.lands || [], (land) => land.name || land.label),
        }))
      )
    })
  }, [errorHandler])

  const value = {
    options,
    setOptions,
    groupedOptions,
    load,
  }

  useEffect(() => {
    load()
    // Load the search index once on mount; errorHandler identity changes every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
}
